import { useCalendarApi } from "../api/CalendarApiClient";
import { CalendarFrontendService } from "../services/CalendarFrontendService";

export const useCalendarService = (): CalendarFrontendService =>
  new CalendarFrontendService(useCalendarApi());
